import React, { useContext } from "react";
import BtnPlain from "../../../../../../../Components/Buttons/BtnPlain";
import { FaRegTrashAlt } from "react-icons/fa";

import TableContext from "./TContext";
import useAxios from "../../../../../../../Hooks/useAxios";
import useApp from "../../../../../../../Hooks/useApp";

const TableActions = ({ doc }) => {
  const request = useAxios();
  const { setShowSuccessModal, setModalMessage } = useApp();
  const { getUserAllocations } = useContext(TableContext);

  const handleDelete = async () => {

    let res = await request({
      method: "DELETE",
      url: `hospital/insurance/scheme/${doc.id}`,
    });
    if (res !== "error") {
      setModalMessage("Scheme Deleted!");
      setShowSuccessModal(true);
      getUserAllocations()
    }
  };

  return (
    <div className="flex-1">
      <div className=" gap-y-2 flex flex-col text-sm">
        <BtnPlain activeBgColor="white" bg="white" click={handleDelete}>
          <div className=" gap-x-2 flex items-center active:opacity-50 cursor-pointer">
            <p className="  text-red">
              <FaRegTrashAlt />
            </p>
            <p className=" "></p>
          </div>
        </BtnPlain>
      </div>
    </div>
  );
};

export default TableActions;
